export default __webpack_public_path__ + "images/c25b67fcc7f6659d0f9e9bdaa32fae32.png";